import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
    SandboxService,
    type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useConvertSandboxToPublic = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    onClose: () => void
): UseMutationResult<
    Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
    unknown,
    string,
    unknown
> => {
    const queryClient = useQueryClient();

    return useMutation(
        async (sandboxId: string) => {
            return await handleRequest(
                SandboxService.putApiIdentityApiSandboxConvert(sandboxId)
            );
        },
        {
            onSuccess: async (data) => {
                toast.success(
                    <ToastComponent
                        label='Success'
                        message={data?.message ?? 'Sandbox converted to public successfully.'}
                    />
                );
                await queryClient.invalidateQueries('getSwitchSandboxList');
                onClose && onClose();
            },
            onError: (err) => {
                onClose && onClose();
                console.log('error', err);
            },
        }
    );
};

export default useConvertSandboxToPublic;

